export default __webpack_public_path__ + "static/media/puppyFemalewithoutCollar.31a47aa6.jpg";